export const environment = {
  production: false,
  API_URL: 'https://api.dev.gatewee.com.br/v1',
};
